// Consumer Duty: the routes and the sidebar rows of `wealth.compliance.consumer-duty` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.compliance.consumer-duty',
    routes: [
        {
            frontend: 'comply',
            path: 'consumer-duty',
            lazy: () => import('@/pages/comply/consumer-duty/page'),
        },
        {
            frontend: 'comply',
            path: 'consumer-duty/pillar/:pillar',
            lazy: () => import('@/pages/comply/consumer-duty/pillar/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'consumer-duty',
            label: 'Consumer Duty',
            href: '/comply/consumer-duty',
            icon: 'Heart',
            group: 'consumer-duty',
            order: 210,
            wip: true,
        },
    ],
});
